import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { RetryLink } from 'apollo-link-retry';
// eslint-disable-next-line import/no-extraneous-dependencies
import { createLink } from 'apollo-absinthe-upload-link';
// eslint-disable-next-line import/no-extraneous-dependencies
import fetch from 'unfetch';

import {
  auth, consts, isArray, l, serverError,
} from 'src/utils';
import { BACKEND_HTTP_PATH } from 'src/config';
import settings from 'src/features/settingsByApollo';
import eventBus from './eventBus';

function fibonacciDelay(attempt) {
  const fib = (n) => (n <= 1 ? n : fib(n - 1) + fib(n - 2));
  return fib(attempt) * 1000 + Math.random() * 1000; // Фибоначчи в миллисекундах + размазывание
}

const UNAUTHORIZED = 'unauthorized';

function logout() {
  eventBus.$emit(consts.FORCE_LOGOUT);
}

const httpLink = createLink({
  uri: `${BACKEND_HTTP_PATH}api/secure`,
  fetch,
});

const authLink = setContext((_, { headers }) => {
  const jwt = auth.getToken(settings.getCurrentToken());
  return {
    headers: {
      ...headers,
      authorization: jwt ? `Bearer ${jwt}` : '',
    },
  };
});

const errorLink = new ApolloLink((operation, forward) => forward(operation).map((response) => {
  const {
    response: { status },
  } = operation.getContext();
  const { errors } = response;
  if (status === 401) {
    l.error(`Произошел выход из системы  (причина ${status})`);
    logout();
  } else if (errors && isArray(errors)) {
    errors.forEach((item) => {
      if (item.message.indexOf(UNAUTHORIZED) > -1) {
        logout();
      } else if (item.error) {
        if (item.error.code === consts.UNAUTHORIZED) {
          logout();
        } else {
          serverError.handle(item.error, item.path[0], item.message);
        }
      }
    });
  } else if (errors) {
    l.error('errors must be array');
    l.error(`errors = ${JSON.stringify(errors)}`);
  }

  return response;
}));

const retryLink = new RetryLink({
  delay: {
    initial: 1000 + Math.random() * 1000,
    max: Infinity,
    jitter: false,
  },
  attempts: {
    max: 5,
    delay: fibonacciDelay,
    retryIf: (error, operation) => {
      const { response } = operation.getContext();
      if (response && (response.status === 401 || response.status === 403)) {
        return false;
      }
      return !!error;
    },
  },
});

const link = ApolloLink.from([authLink, errorLink, retryLink, httpLink]);

const client = new ApolloClient({
  link,
  cache: new InMemoryCache(),
  connectToDevTools: true,
});

export default { client };
